import { z } from 'zod';

/**
 * Creates a Zod schema for connection form validation
 * @param t Translation function
 * @returns Zod schema for organization form
 */
export const createConnectionFormSchema = (t: (key: string, options?: any) => string) =>
  z.object({
    oauth: z
      .string()
      .url(t('authenticated.onboarding.integrations:validation.validURL'))
      .optional()
      .or(z.literal('')),
    clientID: z.string().min(1, {
      message: t('authenticated.onboarding.integrations:validation.requiredField'),
    }),
    clientSecret: z.string().min(1, {
      message: t('authenticated.onboarding.integrations:validation.requiredField'),
    }),
  });

export type ConnectionFormValues = z.infer<ReturnType<typeof createConnectionFormSchema>>;
